import { sanitizeUrl } from "@braintree/sanitize-url";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class AppFooter extends Vue {
  cleanCguLink = sanitizeUrl(this.$t("components.pageFooter.cguLink.href").toString());
  cleanPrivacyLink = sanitizeUrl(this.$t("components.pageFooter.privacyLink.href").toString());
}
